module.exports = "../../static/img/nohomeBG.050e8ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImage/nohomeBG.png
// module id = EEhl
// module chunks = 36